module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout w-100 m-2"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("目前操作藥盒：" + _vm._s(_vm.selectedDevicesID.indexOf(_vm.currentDevice.id.toString()) + 1) + " / " + _vm._s(_vm.selectedDevicesID.length))])]), _c('Action', {
    attrs: {
      "deviceId": _vm.currentDevice.id,
      "defaultNum": _vm.fakeNumber,
      "checkNum": _vm.fakeNumber,
      "hasSlot": true,
      "valueMoreThanZero": false
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [(_vm.actionType === 'lock') ? _c('div', {
    staticClass: "instruction-wrapper"
  }, [_c('font-awesome-layers', {
    staticClass: "fa-3x fa-fw"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.arrowDownIcon,
      "transform": "shrink-6 up-10"
    }
  }), _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.boxOpenIcon,
      "transform": "down-1"
    }
  })], 1), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請將藥物放入藥盒內")])], 1) : _vm._e(), (_vm.actionType === 'unlock') ? _c('div', {
    staticClass: "instruction-wrapper"
  }, [_c('font-awesome-layers', {
    staticClass: "fa-3x fa-fw"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.arrowUpIcon,
      "transform": "shrink-6 up-10"
    }
  }), _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.boxOpenIcon,
      "transform": "down-1"
    }
  })], 1), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請將藥物自藥盒取出")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-468283bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LockBoxFlow/ConfirmFlow.vue
// module id = 1458
// module chunks = 1